/* istanbul ignore file */
// @todo: remove istanbul ignore

import React, { useEffect } from 'react';
import { storeBuilder } from '../../utils/ReduxStoreUtil';
import { Provider } from 'react-redux';
import App from '../../internals/App';
import { Namespace, setCallback, configureApolloForCommerce } from '@chegg/commerce-utils';
import { createTheme, ThemeProvider, themes } from '@chegg-ui/theme';
import { OptimizelyContext } from './OptimizelyContext';
var PaymentMethods = function PaymentMethods(props) {
  var config = props.config,
    callback = props.callback,
    _props$commands = props.commands,
    commands = _props$commands === void 0 ? [] : _props$commands,
    optimizelyClient = props.optimizelyClient;
  var store = storeBuilder().getStore(config);
  var theme = createTheme(themes.horizon);
  setCallback(callback, Namespace.PAYMENT_METHODS);

  // Execute commands from props if non-empty
  commands.length && storeBuilder().executeCommands(commands);
  useEffect(function () {
    return function () {
      storeBuilder().resetStore();
    };
  }, []);
  var cheggBaseUrl = config.authorization.cheggBaseUrl;
  useEffect(function () {
    var isProd = !(cheggBaseUrl !== null && cheggBaseUrl !== void 0 && cheggBaseUrl.includes('.live.test.cheggnet.com'));
    configureApolloForCommerce(isProd, window.location.hostname);
  }, []);
  return /*#__PURE__*/React.createElement(Provider, {
    store: store
  }, /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/React.createElement(OptimizelyContext.Provider, {
    value: optimizelyClient
  }, /*#__PURE__*/React.createElement(App, props))));
};
export default PaymentMethods;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/externals/PaymentMethods/index.js
// module id = 4364
// module chunks = 11